import { useEffect, useRef } from 'react';
import { VariableSizeList } from 'react-window';

export function useResetCache(data: number) {
  const ref = useRef<VariableSizeList>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}
